export const probabilityToString = prob => {
    if (prob === undefined) throw new DOMException('Tried to get pretty probability from undefined')
    if (prob < 0.09) return 'Low'
    if (prob < 0.37) return 'Medium'
    return 'High'
}
